import SocialLinks from './SocialLinks'

export default SocialLinks
